/* W11 — P-2 Memory Recall pré-décisionnel : avant de décider, NOAM confronte
 * l'estimation annoncée à la calibration RÉELLE de l'organisation. INSUFFICIENT_DATA honnête. */
import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { BrainCircuit, Loader2 } from "lucide-react";

const fmtMoney = (v, cur = "CHF") => v == null ? "—" : new Intl.NumberFormat("fr-CH", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(v);

export function MemoryRecallPanel({ system, p, refKey }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (p == null || isNaN(p)) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setLoading(true);
      api.get(`/workspace/decision-recall?p=${p}${system ? `&system=${system}` : ""}${refKey ? `&ref_key=${encodeURIComponent(refKey)}` : ""}`)
        .then((r) => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
    }, 400);
    return () => clearTimeout(timer.current);
  }, [system, p, refKey]);

  if (p == null || isNaN(p)) return null;
  const cal = data?.calibration;
  return (
    <div className="p-2.5 rounded border border-[#7F77DD]/30 bg-[#7F77DD]/5 space-y-1.5" data-testid="memory-recall-panel">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-[#7F77DD]">
        <BrainCircuit className="w-3.5 h-3.5" /> Mémoire de l'organisation — avant de décider
        {loading && <Loader2 className="w-3 h-3 animate-spin" />}
      </div>
      {data && (
        <>
          <div className={`text-[11px] ${cal?.status === "OK" ? "text-zinc-200" : "text-zinc-500"}`} data-testid="recall-message">
            {data.message}
          </div>
          {data.suggestion && (
            <div className="text-[11px] text-[#EF9F27]" data-testid="recall-suggestion">{data.suggestion}</div>
          )}
          {(data.similar_decisions || []).length > 0 && (
            <div className="space-y-0.5" data-testid="recall-similar">
              <div className="text-[9px] uppercase tracking-widest text-zinc-600">Décisions comparables</div>
              {data.similar_decisions.map((s) => (
                <div key={s.id} className="text-[10px] text-zinc-400 flex gap-2 flex-wrap">
                  <span className="text-zinc-300 truncate max-w-[240px]">{s.title}</span>
                  {s.decided_p_success != null && <span>P {Math.round(s.decided_p_success * 100)}%</span>}
                  {s.verdict && <span>{s.verdict}</span>}
                  {s.payoff_realized_chf != null && (
                    <span className={s.payoff_realized_chf > 0 ? "text-[#1D9E75]" : "text-[#E24B4A]"}>
                      réalisé {fmtMoney(s.payoff_realized_chf, s.currency)}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
